import {useContext, useState, useEffect} from 'react';
import { Box, Divider,Snackbar, Alert, Modal, Typography } from '@mui/material';
import styles from './AppHeader.module.scss';
import AppLogo from '../appLogo/AppLogo';
import UserSessionData from '../../userSessionData/UserSessionData';
import { Link, useNavigate } from 'react-router-dom';
import { requestLogout, useAuthentication } from '../../../common/requests/LoginRequest';
import { getAlertType, getLocalStorageAuthVariableName } from '../../../common/Utils';
import { ToastNotification } from '../../../common/Interfaces';
import { ToastType } from '../../../common/requests/Enums';
import TitleSubtitle from '../formControls/titleSubtitle/TitleSubtitle';
import CancelButton from '../formControls/buttons/CancelButton';
import SuccessButton from '../formControls/buttons/SuccessButton';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../context/AuthContext';
import BasicModal from '../basicModal/BasicModal';

export default function AppHeader () {
    const {authenticated, setAuthenticated} = useContext(AuthContext)
    const {t} = useTranslation();
    const auth = useAuthentication();
    const navigate = useNavigate();
    const [openToast, setOpenToast] = useState<boolean>(false);
    const [toastInfo, setToastInfo] = useState<ToastNotification|undefined>(undefined);
    const [openConfirmLogoutModal, setOpenConfirmLogoutModal] = useState<boolean>(false);

    const confirmLogout = () => {
        setOpenConfirmLogoutModal(true);
    }

    const handleLogout = async () => {
        setOpenConfirmLogoutModal(false);
        setOpenToast(false);

        setToastInfo({
            type: ToastType.info,
            message: t("LOGGINOUT"),
        })

        setOpenToast(true);

        await requestLogout(auth.sessionData.SessionId, auth.token ?? '');
        setOpenToast(false);
        localStorage.removeItem(getLocalStorageAuthVariableName());
        setAuthenticated(false);
        navigate("/login");
    }

    return auth.isAuthenticated ? (
        <Box className={styles.lateralPadding}>
            <BasicModal
                openModal={!!openConfirmLogoutModal}
                setOpenModal={() => {setOpenConfirmLogoutModal(false)}}
                title={t("LOGOUT")} 
                subTitle={t("LOGOUTCONFIRMATION")}
                successButton={{
                    id: 'LogoutButton',
                    label: t("LOGOUT"),
                    onClick: handleLogout
                }}
                cancelButton={{
                    id: 'CancelButton',
                    label: t("CANCEL"),
                    onClick: () => {setOpenConfirmLogoutModal(false)}
                }}
             />

            <Snackbar
            open={!!openToast}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            autoHideDuration={3000}
            onClose={() => {
                setOpenToast(false);
            }}
            >
                <Alert severity={getAlertType(toastInfo?.type ?? ToastType.info)}>
                    {toastInfo?.message}
                </Alert>
            </Snackbar>

            <Box className={styles.container}>
                <Box className={styles.rowContainer}>
                <Link to="/">
                    <AppLogo/>
                </Link>
                <Typography className={styles.normalText}>
                    {`${t("VERSION")} ${t("APPVERSION")}`}
                </Typography>
                </Box>
                
                <UserSessionData
                    UserFullName={auth.sessionData?.FullName}
                    UserName={auth.sessionData?.UserName}
                    handleLogout={confirmLogout}
                />
            </Box>
            <Divider/>
        </Box>
    )
    :
    (<Box/>);
}